var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index_wrap"},[_c('img',{staticClass:"icon",attrs:{"src":require("./img/1.png")}}),_c('div',{staticClass:"text"},[_vm._v("您的资料已提交，平台审核中。")])])
}]

export { render, staticRenderFns }